//Librairies
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { allReducers } from "./stores/index";
import * as serviceWorker from './serviceWorker';
//Application
import App from "./App";
import "./styles/index.css";

fetch('../../../appsettings.json')
  .then(response => response.json())
  .then(config => {
    window.appSettings = config;
    ReactDOM.render(
      <Provider store={allReducers}>
      <App />
      </Provider>,
      document.getElementById("root")
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
  });